import React from 'react';
import Map from './map';

function App() {
  return (
    <div>
      <Map />
    </div>
  );
}

export default App;
